<script setup lang="ts">
import { ActionButton, EmptyState } from '@taler/ui'
import { type RouteLocationRaw, RouterLink } from 'vue-router'
import { useI18n } from 'vue-i18n'

defineProps<{ to: RouteLocationRaw; list: string }>()

const { t } = useI18n()
</script>

<template>
  <EmptyState :title="t('app.notFound.title')" :body="t('app.notFound.body')">
    <template #action>
      <ActionButton :as="RouterLink" :to="to" variant="secondary">
        {{ t('app.notFound.backTo', { list }) }}
      </ActionButton>
    </template>
  </EmptyState>
</template>
